import {faPlus} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button, Group} from '@mantine/core';
import {Link} from 'react-router-dom';
import {EmailEvaluationsService} from '../api/generated/EmailEvaluationsService';
import {BasicPage} from '../components/basic-page';
import {
  PagedDataTableConfig,
  renderEditButton,
  usePagedDataTable,
} from '../hooks/paged-data-table/use-paged-data-table';
import {ROUTES} from '../routes';

const RuntimeConfig = {
  renderActions: (
    <Button component={Link} to={ROUTES.ADMIN.EMAIL_EVALUATIONS.CREATE.path}>
      <Group gap={'xs'}>
        <FontAwesomeIcon icon={faPlus} /> New Email Evaluation
      </Group>
    </Button>
  ),
};

export const EmailEvaluationListing = () => {
  const pagedDataTable = usePagedDataTable(
    EmailEvaluationsService.getAll,
    TableConfig,
    {
      ...RuntimeConfig,
    },
  );

  return <BasicPage title='Email Evaluations'>{pagedDataTable}</BasicPage>;
};

const TableConfig = PagedDataTableConfig(EmailEvaluationsService.getAll, {
  columns: [
    {
      title: '',
      accessor: '',
      render: (item) =>
        renderEditButton({
          item: {...item, id: Number(item.id)},
          descriptor: 'Email Evaluation',
          route: ROUTES.ADMIN.EMAIL_EVALUATIONS.DETAIL.path,
        }),
      width: 50,
    },
    {
      title: 'Site ID',
      accessor: 'partnerSiteId',
    },
    {
      title: 'ARF Number',
      accessor: 'partnerSiteArfNumber',
    },
    {
      title: 'Partner Site',
      accessor: 'partnerSiteName',
    },
    {
      title: 'Email User ID',
      accessor: 'emailUserId',
    },
    {
      title: 'Email',
      accessor: 'email',
    },
    {
      title: 'Filter on Entered By User',
      accessor: 'filterOnEnteredByUserName',
    },
    {
      title: 'Filter on Level of Service',
      accessor: 'filterOnLevelOfServiceDescription',
      render: (item) => item.filterOnLevelOfServiceDescription ?? 'All',
    },
    {
      title: 'Filter on Can be Repaired',
      accessor: 'filterOnCanBeRepaired',
    },
    {
      title: 'Filter on Client Named',
      accessor: 'filterOnClientNamed',
    },
  ],
  searchFieldNames: [
    'email',
    'partnerSiteArfNumber',
    'filterOnEnteredByUserName',
    'filterOnLevelOfServiceDescription',
    'filterOnCanBeRepaired',
    'filterOnClientNamed',
  ],
});
